import React, { useEffect, useState } from 'react';
import ModulesList from './components/moduleList';
import ModulesModal from './components/moduleModal';
import useModuleState from './hooks/useModuleState';
import { message } from 'antd';

const Modules = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const { modules, loading, addOrUpdate } = useModuleState();

  const [modalOpen, setModalOpen] = useState(false);
  const [addModule, setAddModule] = useState(null);

  const handleAdd = () => {
    setAddModule(null);
    setModalOpen(true);
  };

  const handleSave = async (role) => {
    const response = await addOrUpdate(role);
    if (response?.success) {
      setModalOpen(false);
      messageApi.success('Module created successfully', 5);
    }
    return response;
  };

  return (
    <>
      {contextHolder}
      <ModulesList
        modules={modules}
        loading={loading}
        onAdd={handleAdd}
      />
      <ModulesModal
        visible={modalOpen}
        onCancel={() => setModalOpen(false)}
        onSave={handleSave}
        initialData={addModule}
        modules={modules}
      />
    </>
  );
};

export default Modules;